import { FC, PropsWithChildren, useReducer } from "react";

import { UIContext } from "./UIContext";
import { uiReducer } from "./uiReducer";


export interface UIState {
    isSideMenuOpen: boolean;
    isSiderCollapsed: boolean;
    isLoading: boolean;
    showError: boolean;
    menuSelect: any;
}

const UI_INITIAL_STATE: UIState = {
    isSideMenuOpen: false,
    isSiderCollapsed: false,
    isLoading: true,
    showError: false,
    menuSelect: ['15'],
};

export const UIProvider: FC<PropsWithChildren> = ({ children }) => {

    const [state, dispatch] = useReducer(uiReducer, UI_INITIAL_STATE);

    const toogleSideMenu = () => dispatch({ type: '[UI] - TOOGLE SIDE MENU' });

    const toggleSiderCollapsed = () => dispatch({ type: '[UI] - TOOGLE SIDER COLLAPSED' });

    const setIsLoading = (isLoading: boolean) => dispatch({ type: '[UI] - SET IS LOADING', payload: isLoading });

    const setShowError = (show: boolean) => dispatch({ type: '[UI] - SHOW ERROR', payload: show });

    const setMenuSelect = (menu: any) => dispatch({ type: '[UI] - MENU SELECT', payload: menu });
    return (
        <UIContext.Provider value={{
            ...state,
            toogleSideMenu,
            toggleSiderCollapsed,
            setIsLoading,
            setShowError,
            setMenuSelect,
        }}>
            { children }
        </UIContext.Provider>
    )
}